import React, { useState } from 'react';
import { Form, Button, Container, Row } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import { fnEmailValidation } from '../reusables/HelperFormValidation';
import { showToast } from '../reusables/CommonFunction';
import axiosInstance from '../../utils/axios';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';

export default function ForgotPassword() {
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [resetPasswordState, setResetPasswordState] = useState({
        email_id: "",
    });
    const [resetPasswordErrors, setResetPasswordErrors] = useState({
        email_id: "",
    });

    const onChange = (oEvent) => {
        setResetPasswordState({
            ...resetPasswordState,
            [oEvent.target.name]: oEvent.target.value.toLowerCase(),
        });
        if (!!resetPasswordErrors[oEvent.target.name])
            setResetPasswordErrors({
                ...resetPasswordErrors,
                [oEvent.target.name]: null,
            });
    };

    const onPressForgotPassword = (oEvent) => {
        oEvent.preventDefault();
        setIsSubmitting(true);
        let fErrorStatus = []
        const aEmailCheck = ['email_id']
        fErrorStatus = fnEmailValidation(resetPasswordState, resetPasswordErrors, setResetPasswordErrors, aEmailCheck, fErrorStatus)

        if (fErrorStatus.length === 0) {
            setLoading(true);
            axiosInstance
                .post("/user/reset-password/", resetPasswordState, { skipAuth: true })
                .then(response => {
                    setResetPasswordErrors({
                        email_id: ''
                    })
                    setResetPasswordState({
                        email_id: ''
                    })

                    if (response.status === 202) {
                        showToast("success", response.data.message);
                    } else {
                        showToast("error", response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response) {
                        showToast("error", error.response.data.message);
                    } else if (error.request) {
                        showToast("error", "No response from server. Please try again later.");
                    } else {
                        showToast("error", "An error occurred while sending the request. Please try again later.");
                    }
                })
                .finally(() => {
                    setLoading(false);
                    setResetPasswordErrors({
                        email_id: ''
                    })
                    setIsSubmitting(false);
                });
        } else {
            setIsSubmitting(false);
        }
    }

    return (
        <>
            <Container className="ml-3 mr-3 mb-3">
                <Row>
                    <div className='col-md-12'>
                        <div className='content-section col-md-8'>
                            <legend className="border-bottom mb-4">Forgot Password</legend>
                            <Form autoComplete="off" noValidate>
                                <Form.Group className="mb-3" controlId="formEmailAddress">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email_id"
                                        value={resetPasswordState.email_id}
                                        onChange={onChange}
                                        isInvalid={resetPasswordErrors.email_id}
                                    />
                                    <Form.Text className="text-muted">We'll never share your email address with anyone else.</Form.Text>
                                    <Form.Control.Feedback type="invalid">{resetPasswordErrors.email_id}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formResetPassword">
                                    <Button type="submit" variant="primary" className="form-control" onClick={onPressForgotPassword}>
                                        { isSubmitting ? "Please wait..." : "Reset Password" }
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Row>
                <ToastContainer />
                <BusyLoaderOverlay show={loading} />
            </Container>
        </>
    );
}